// extracted by mini-css-extract-plugin
module.exports = {"root":"ConfirmationSlide_root__PUIa3","form":"ConfirmationSlide_form__qNyq5","header":"ConfirmationSlide_header__TLt45","message":"ConfirmationSlide_message__XaJJf"};